import { memo } from 'react';
import { Fragment } from 'react/jsx-runtime';
import { AddRepresentativesFormField } from '../AddRepresentativesModal/AddRepresentativesModal.styles';
import { InputLabel, TextField } from '@material-ui/core';
import { useRepresentativesAgencyInput } from '../../hooks/useRepresentativeAgencyInput';
import { IAgenciesDivisionAttributes } from 'shared/interfaces/IRepresentatives';
import { Autocomplete } from '@material-ui/lab';
import { CheckBox } from '@room-match/shared-ui-components';
import { HandleSetFieldValueValueProps } from '../../model/AddRepresentativeSchema';
import AddRepresentativesFormListAgencyTypeField from '../AddRepresentativesFormListAgencyTypeField/AddRepresentativesFormListAgencyTypeField';

type AddRepresentativesFormListAgencyProps = {
  country: string;
  access_code?: string;
  division_ids?: IAgenciesDivisionAttributes[];
  code_required?: boolean;
  division_required?: boolean;
  handleSetFieldValue: HandleSetFieldValueValueProps;
};

const AddRepresentativesFormListAgency = ({
  country,
  access_code,
  division_ids = [],
  code_required,
  division_required,
  handleSetFieldValue,
}: AddRepresentativesFormListAgencyProps) => {
  const { agencyDivision, handleAgencyOnChangeCB } = useRepresentativesAgencyInput(handleSetFieldValue);

  return (
    <Fragment>
      {/* Agency Field, Searching and Typing */}
      <AddRepresentativesFormField key={'Agency'}>
        <InputLabel style={{ fontSize: 14 }}>Select Agency / Manager</InputLabel>
        <AddRepresentativesFormListAgencyTypeField handleOnChange={handleAgencyOnChangeCB} country={country} />
      </AddRepresentativesFormField>

      {/* Agency Code Field */}
      {code_required ? (
        <AddRepresentativesFormField key={'Agency Code'}>
          <InputLabel style={{ fontSize: 14 }}>Agency Code</InputLabel>
          <InputLabel style={{ fontSize: 11, marginTop: -5 }}>
            * Please contact your agency for their security code, in order to add them as a representative.
          </InputLabel>
          <TextField
            value={access_code}
            error={Boolean(!access_code)}
            onChange={(e) => handleSetFieldValue('access_code', e.target.value)}
            variant="outlined"
            fullWidth
            placeholder="Agency Code"
          />
        </AddRepresentativesFormField>
      ) : null}

      {/* Division selections */}
      {division_required ? (
        <AddRepresentativesFormField key={'Agency Division'}>
          <InputLabel style={{ fontSize: 14 }}>Divisions</InputLabel>
          <Autocomplete
            multiple
            value={division_ids}
            fullWidth
            id="checkboxes-tags-demo"
            options={[...agencyDivision]}
            limitTags={3}
            disableCloseOnSelect
            getOptionLabel={(option) => option.name}
            getOptionSelected={(option, value) => option.id === value.id}
            getOptionDisabled={(option) => division_ids[0]?.name === 'Any' && option.name !== 'Any'}
            onChange={(_, value) => {
              const anyValue = value[value?.length - 1].id === 'Any';
              handleSetFieldValue('division_ids', anyValue ? [value[value?.length - 1]] : value);
            }}
            renderOption={(option, { selected }) => (
              <Fragment>
                <CheckBox checked={selected} />
                {option.name}
              </Fragment>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                error={division_ids?.length === 0}
                variant="outlined"
                placeholder={division_ids?.length > 0 ? undefined : 'Select Divisions'}
              />
            )}
          />
        </AddRepresentativesFormField>
      ) : null}
    </Fragment>
  );
};

export default memo(AddRepresentativesFormListAgency);
